import ApolloLinkTimeout from 'apollo-link-timeout';
export default (function (baseLink, timeout) {
    var timeoutLink = new ApolloLinkTimeout(timeout);
    return timeoutLink.concat(baseLink);
});
//# sourceMappingURL=concatTimeoutLink.js.map